import { Center, Paper, Stack, Text } from "@mantine/core";
import { IconUserStar } from "@tabler/icons-react";
import SectorDashboardCard from "./SectorDashboardCard";

function ExpertsFacilitatorsComingSoonContent() {
  return (
    <Paper
      p="md"
      radius="md"
      style={{
        border: "1px dashed #CBD5E1",
        backgroundColor: "#F8FAFC",
      }}
    >
      <Stack gap="sm" align="center" py="sm">
        <Center
          style={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            backgroundColor: "#EFF6FF",
          }}
        >
          <IconUserStar size={20} color="#94A3B8" />
        </Center>
        <Text
          size="xs"
          fw={600}
          c="#64748B"
          px={10}
          py={4}
          style={{ borderRadius: 999, backgroundColor: "#EDF2F7" }}
        >
          Coming Soon
        </Text>
        <Text size="xs" c="dimmed" ta="center" maw={280}>
          Experts and facilitators for this sector are launching soon.
        </Text>
      </Stack>
    </Paper>
  );
}

export default function SectorExpertsFacilitatorsCard() {
  return (
    <SectorDashboardCard
      title="Experts & Facilitators"
      subtitle="Who can help."
    >
      <ExpertsFacilitatorsComingSoonContent />
    </SectorDashboardCard>
  );
}
